import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import {PermIdentity} from '@material-ui/icons';
import moment from 'moment'



const useStyles = makeStyles((theme) => ({
  commentItem: {
    paddingLeft: 0,
    paddingRight: 0,
    marginBottom: theme.spacing(3),
  },
  
  commentDate: {
    color: '#666666',
  },
  
  commentTitle: {
    marginBottom: theme.spacing(1),
    color: '#333333',
  },
  
  commentText: {
    fontSize: '14px',
    color: 'rgba(102, 102, 102, 0.87)',
  },
}));


function CommentItem(props) {
  const classes = useStyles();

  const {user, comment, date} = props.info

  let time = moment(date);
  time = time.format('DD.MM.YYYY');

  return (
    <div>
      <Typography gutterBottom variant="caption" component="div" className={classes.commentDate}>{time}</Typography>
      <ListItem className={classes.commentItem} alignItems="flex-start">
        <ListItemAvatar>
          <Avatar style={{background: '#E2E2E2'}}>
            <PermIdentity style={{color: '#666666'}}/>
          </Avatar>
        </ListItemAvatar>
        <ListItemText 
          classes={{
            primary: classes.commentTitle,
            secondary: classes.commentText,
          }} 
          style={{color: '#333333'}}
          primary={user.fullName}
          secondary={comment} 
        />
      </ListItem>
    </div>

  );
}

export default CommentItem;
